import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import prettifyApi from '../Api/htmlPrettify'
import blogPostApi from '../Api/blog'

import  i18n  from "@/plugin/vuei18n";


export default new Vuex.Store({
	state: {
		generatedCode: '',
		blogPosts: [],
		mobileMenuIsOpen: false,
		headerDropdownEl: null
	},
	actions: {
		prettyCode: async ({commit}, html) => {
			try {
				const RES = await prettifyApi.prettifyHtml({html});
				await commit('updateGeneratedCode', RES.data.prettyHtml);
			} catch (e) {
				console.log(e.response);
			}
		},
		getBlogPosts: async ({commit}) => {
			try {
				const RES = await blogPostApi.getPosts(i18n.locale);
				await commit('updateBlogPosts', RES.data.data)
			} catch (e) {
				console.log(e.response);
			}
		}
	},
	mutations: {
		updateGeneratedCode: (state, val) => {
			state.generatedCode = val;
		},
		updateBlogPosts: (state, val) => {
			state.blogPosts = val;
		},
		updateMobileMenuIsOpen: (state, val) => {
			state.mobileMenuIsOpen = val;
		},
		updateHeaderDropdownEl: (state, val) => {
			state.headerDropdownEl = val;
		}
	}
});